'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { formatRate } from '../../util/formatters/format-rate.js';

const ReviewDimension = ({ rate, dimension, }) => {
    return rate && rate != 0 ? (jsxs("div", { className: "flex w-full items-center space-x-9", children: [jsx("h2", { className: "grow whitespace-nowrap text-lg font-medium leading-6 text-leland-gray-dark", children: dimension }), jsxs("div", { className: "flex items-center space-x-1.5", children: [jsx("div", { className: "h-1.5 w-28 rounded-full bg-leland-gray-stroke", children: jsx("div", { className: "h-full rounded-full bg-leland-gray-dark", style: { width: `${(rate / 5) * 100}%` } }) }), jsx("p", { className: "text-lg text-leland-gray-dark", children: formatRate(rate) })] })] })) : null;
};

export { ReviewDimension };
//# sourceMappingURL=dimension.js.map
